import React, { useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { browserHistory } from "rdx/configureStore";
import { useSession } from "hooks/useSession";
import { generateErrorUID } from "util/generate-error-uid";
import RootFallback from "./Fallbacks/RootFallback";
import { logToAirbrake } from "../../config/airbrake/log-to-airbrake";
import type { ErrorBoundaryProps } from "./types";

type RootBoundaryProps = ErrorBoundaryProps;

export default function RootBoundary({ children }: RootBoundaryProps) {
  const [errorUID] = useState(generateErrorUID);
  const { session } = useSession();

  return (
    <ErrorBoundary
      fallbackRender={(fallbackProps) => <RootFallback {...fallbackProps} errorUID={errorUID} />}
      onError={(error, info) => logToAirbrake({ error, info, errorUID, session, browserHistory })}
    >
      {children}
    </ErrorBoundary>
  );
}
